import { render, staticRenderFns } from "./ScanResults.vue?vue&type=template&id=94c8e1c2&scoped=true"
import script from "./ScanResults.vue?vue&type=script&lang=js"
export * from "./ScanResults.vue?vue&type=script&lang=js"
import style0 from "./ScanResults.vue?vue&type=style&index=0&id=94c8e1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c8e1c2",
  null
  
)

export default component.exports